import * as api from "@/common/api";
import {
  JoinRequest,
  LoginRequest,
  UserFindIdRequest,
  UserInfo,
  UserResetPasswordRequest,
  UserUpdateRequest,
} from "../class";
import { HeaderOption } from "@/common/api";
import store from "@/common/store";
import * as core from "@/common/utils/core";
import { DataResponse } from "@/common/class";
import { UserDetailInfo } from "@/user/class/index";

/**
 * 아이디 중복확인
 * @param id 아이디
 * @returns 존재여부
 */
export const idDuplicateCheck = async (id: string) => {
  const res = await api.get("/api/v1/users/duplicateId/" + id);
  console.log("idDuplicateCheck res : ", res);
  return res.data;
};

/**
 * 회원가입
 * @param payload
 * @returns
 */
export const join = async (payload: JoinRequest) => {
  const res = await api.post("/api/v1/users", payload);
  console.log("join res : ", res);
  const response = new DataResponse();
  response.bind(res);
  return response;
};

/**
 * 로그인
 * @param payload
 * @returns
 */
export const login = async (payload: LoginRequest) => {
  //
  const option = new HeaderOption();
  option.contentType = "multipart/form-data";
  const res = await api.post(
    "/api/v1/users/login",
    payload.getFormData(),
    option
  );
  console.log("login res: ", res);
  if (res.status == 200) {
    const userInfo = new UserInfo();
    userInfo.setUserInfoByResponse(res);
    return userInfo;
    //
  } else if (res.status == 401) {
    // alert("아이디와 비밀번호를 확인해주세요");
    return null;
  } else {
    console.log("login else error");
    return null;
  }
};

/**
 * 서버 세션체크
 * @returns
 */
export const sessionCheck = async () => {
  const res = await api.get("/api/v1/users/session-check");
  console.log("sessionCheck res: ", res);
  return res;
};

/**
 * 로그아웃
 * @returns
 */
export const logout = async () => {
  const res = await api.post("/api/v1/users/logout", {});
  console.log("logout res: ", res);
  const response = new DataResponse();
  response.bind(res);
  return response;
};

/**
 * 유저정보 상세조회
 * @param id
 * @returns
 */
export const getUserDetailInfo = async (id: string) => {
  const res = await api.get("/api/v1/users/detail/" + id);
  console.log("getUserDetailInfo res: ", res);
  const response = new UserDetailInfo();
  response.bind(res);
  return response;
  //
};

/**
 * 유저정보 수정
 * @param id
 * @param payload
 * @returns
 */
export const updateUserInfo = async (
  id: string,
  payload: UserUpdateRequest
) => {
  const res = await api.put("/api/v1/users/" + id, payload);
  console.log("updateUserInfo res : ", res);
  return res.data;
};

/**
 * 탈퇴 요청
 * @param payload
 * @returns
 */
export const leave = async (payload: any) => {
  const res = await api.remove("/api/v1/users", payload);
  console.log("leave res : ", res);
  return res.data;
};

export const findId = async (payload: UserFindIdRequest) => {
  const res = await api.get("/api/v1/users/find/id", payload);
  console.log("findId res : ", res);
  return res.data;
};

export const resetPassword = async (payload: UserResetPasswordRequest) => {
  const res = await api.put("/api/v1/users/password/reset", payload);
  console.log("findId res : ", res);
  return res.data;
};

/**
 * 사용자별 권한 목록 조회 (관리자 전용)
 * @returns
 */
export const getUserPermissions = async () => {
  const res = await api.get("/api/v1/users/permissions");
  console.log("getUserPermissions res : ", res);
  return res.data;
};

/**
 * 권한 부여 (관리자 전용)
 * @param userId 대상 사용자 userId
 * @param permissionKey 권한 키
 * @returns
 */
export const grantPermission = async (
  userId: number,
  permissionKey: string
) => {
  const res = await api.post(`/api/v1/users/${userId}/permissions`, {
    permissionKey,
  });
  console.log("grantPermission res : ", res);
  return res.data;
};

/**
 * 권한 회수 (관리자 전용)
 * @param userId 대상 사용자 userId
 * @param permissionKey 권한 키
 * @returns
 */
export const revokePermission = async (
  userId: number,
  permissionKey: string
) => {
  const res = await api.remove(
    `/api/v1/users/${userId}/permissions/${permissionKey}`,
    {}
  );
  console.log("revokePermission res : ", res);
  return res.data;
};

/**
 * 카카오 인증 URL 조회
 * @returns
 */
export const getKakaoAuthUrl = async () => {
  const res = await api.get("/api/v1/kakao/auth-url");
  return res.data;
};

/**
 * 카카오 연동 상태 조회
 * @returns
 */
export const getKakaoStatus = async () => {
  const res = await api.get("/api/v1/kakao/status");
  return res.data;
};

/**
 * 카카오 연동 해제
 * @returns
 */
export const unlinkKakao = async () => {
  const res = await api.remove("/api/v1/kakao/unlink", {});
  return res.data;
};

/**
 * 로또 결과 알림 수신 토글
 * @returns
 */
export const toggleKakaoLottoNotification = async () => {
  const res = await api.put("/api/v1/kakao/lotto-notification", {});
  return res.data;
};
